/**
 * @generated SignedSource<<b3958ea8d7fd84962d13584697b5b00d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateTaskPortalConfigInput = {
  psaTaskId: string;
  clientOrgId?: string | null;
  requiresClientSignoff?: boolean | null;
  signoffApproverForecastPersonId?: number | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateTaskPortalConfigMutation$variables = {
  input: UpdateTaskPortalConfigInput;
};
export type updateTaskPortalConfigMutation$data = {
  readonly updateTaskPortalConfig: {
    readonly taskPortalConfig: {
      readonly requiresClientSignoff: boolean | null;
      readonly signoffApproverForecastPersonId: number | null;
    } | null;
  } | null;
};
export type updateTaskPortalConfigMutation = {
  variables: updateTaskPortalConfigMutation$variables;
  response: updateTaskPortalConfigMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateTaskPortalConfigPayload",
    "kind": "LinkedField",
    "name": "updateTaskPortalConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TaskPortalConfig",
        "kind": "LinkedField",
        "name": "taskPortalConfig",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "requiresClientSignoff",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "signoffApproverForecastPersonId",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateTaskPortalConfigMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateTaskPortalConfigMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "48e52a37d7ca44b62efd8828c348dddc",
    "id": null,
    "metadata": {},
    "name": "updateTaskPortalConfigMutation",
    "operationKind": "mutation",
    "text": "mutation updateTaskPortalConfigMutation(\n  $input: UpdateTaskPortalConfigInput!\n) {\n  updateTaskPortalConfig(input: $input) {\n    taskPortalConfig {\n      requiresClientSignoff\n      signoffApproverForecastPersonId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0bdf23feebd0fa2c82ecc3ac3aec2bb3";

export default node;
